import { Avatar } from '@cycle-app/ui';
import { CalendarIcon, UserIcon, ActivityIcon } from '@cycle-app/ui/icons';
import { format, parseISO } from 'date-fns';
import { memo } from 'react';

import { useDocPanelContext } from 'src/contexts/docPanelContext';
import { useProductAddOn } from 'src/hooks';
import { setLimitationsModal } from 'src/reactives';

import {
  Container, List, Item, Label, Value,
  ActivityContainer, ActivityTitle, ExploreButton,
} from './DocPanelActivity.styles';

export const DocPanelActivity = memo(() => (
  <Container>
    <List>
      <CreatorItem />
      <CreatedAtItem />
    </List>
    <ActivityLog />
  </Container>
));

const CreatorItem = () => {
  const creator = useDocPanelContext(ctx => ctx.doc?.creator);
  if (!creator) return null;
  return (
    <Item>
      <Label>
        <UserIcon />
        Creator
      </Label>
      <Value>
        <Avatar size={20} user={creator} />
        {`${creator.firstName} ${creator.lastName}`}
      </Value>
    </Item>
  );
};

const CreatedAtItem = () => {
  const createdAt = useDocPanelContext(ctx => ctx.doc?.createdAt);
  if (!createdAt) return null;
  return (
    <Item>
      <Label>
        <CalendarIcon />
        Creation date
      </Label>
      <Value>
        {format(parseISO(createdAt), 'MMMM d, yyyy')}
      </Value>
    </Item>
  );
};

const ActivityLog = () => {
  const addOn = useProductAddOn('activity-log');
  if (addOn.isEnabled) return null;
  return (
    <ActivityContainer>
      <ActivityIcon size={24} />
      <ActivityTitle>Activity log</ActivityTitle>
      <p>Access the history of changes</p>
      <ExploreButton
        onClick={() => setLimitationsModal({
          action: 'USE_ADD_ON',
          brand: 'activity-log',
        })}
      >
        Explore
      </ExploreButton>
    </ActivityContainer>
  );
};
